module.exports = __webpack_public_path__ + "img/组1072.5af4481b.png";